import type { ComponentProps } from '@ant-design/x-markdown'

import { LoadingMermaid, MermaidDiagram } from './MermaidDiagram'
import { nodeText } from './utils'

export const CodeBlock = ({
  block,
  lang,
  streamStatus,
  children,
  className
}: ComponentProps) => {
  if (block && lang === 'mermaid') {
    if (streamStatus === 'loading') return <LoadingMermaid />

    return <MermaidDiagram code={nodeText(children)} />
  }

  return <code className={className}>{children}</code>
}
